export default __webpack_public_path__ + "static/media/IMG_5709.c54a8a92.jpeg";